import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ActivationEnd, Router } from "@angular/router";
import { ApsServiceService } from "../aps-service.service";
import { Location } from '@angular/common';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {
  loaderdata: any = false;
  dataexist: any = false;
  data: any = "";
  pages: any = "";
  next: any = "";
  previous: any = "";
  first: any = "";
  last: any = "";
  limit: any = 9;
  eventspage: any = "";
  eventpagenumber: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private searchitem: ApsServiceService,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.getCategory();
    this.router.events.subscribe((event) => {
      //console.log(event)
      //  this.geeventlist();

      if (event instanceof ActivationEnd) {
        //console.log("navigation start");
        this.getCategory();
      }
    });
  }
  njanorupreshnakaran(category:String):void{
  //console.log(`Njan oru vishayam ${category}`)
  }
  getCategory() {
    this.loaderdata = true;
    this.eventpagenumber = this.route.snapshot.params.page;
    //console.log(this.eventpagenumber)
    this.searchitem
      .getcategory(this.eventpagenumber, this.limit)
      .subscribe((responce) => {
        if (responce.status) {
          this.dataexist = true;
          this.pages = parseInt(responce.totalitems);
          this.last = Math.ceil(this.pages / this.limit);

          if (responce.next) {
            this.next = parseInt(responce.next);
          } else {
            this.next = 0;
          }
          if (responce.previous) {
            this.previous = parseInt(responce.previous);
          } else {
            this.previous = 0;
          }

          //console.log(responce.totalitems)
          //  this.data = this.sanitizer.bypassSecurityTrustHtml(responce.data[0].event_details);
          this.data = responce.data;
        } else {
          this.dataexist = false;
        }
        this.loaderdata = false;
      });

    //console.log('data is',this.data)
  }

  // openPdf() {
  //   const pdfPath = 'https://apsblobdeve.blob.core.windows.net/aps-website-files/APS%20Content%20Index.pdf';
  //   const baseHref = this.location['_baseHref'] || '/';

  //   const absolutePath = `${window.location.origin}${baseHref}${pdfPath}`;
  //   // Open the PDF in a new window or tab
  //   window.open(absolutePath, '_blank');
  // }
}